import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-lock-outline",
  templateUrl: "./med-icon-lock-outline.component.html",
})
export class MedIconLockOutlineComponent extends SvgMixinComponent {}
